export default [
  {
    path: '/year-report-2024',
    component: () => import('@/views/yearReport/2024/Index.vue'),
    name: 'yearReport2024',
    meta: {
      backgroundClass: 'bg-yearReport2024',
      title: '2024年度骑行报告',
      visibleShare: true,
      visibleAudio: true,
      auth: 0,
    },
  },
  {
    path: '/year-report-2025',
    component: () => import('@/views/yearReport/2025/Index.vue'),
    name: 'yearReport2025',
    meta: {
      backgroundClass: 'bg-yearReport2025',
      title: 'ZEEHO 2025用户骑行年报',
      visibleShare: true,
      visibleAudio: true,
      auth: 0,
    },
  },
];
